import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select';
import ColumnsDevider from '../../../customControl/ColumnsDevider'
import { TravelAgentBasicInfoModel } from '../../../Models/TravelAgentModels'
import { alphaNumericspace, ApiNotRespondMessage, isValidEmail, isValidGST, onlyNumeric } from '../../../components/commonClass/CommonValidation';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage, SetLocalStorage, UpdateStatusLocalStorage } from '../../../components/commonClass/Session';
import { outletcontext, travelAgentBasicProps } from './TravelAgent.interface';
import Switch from 'react-switch';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import { Modal } from '../../../_helpers/Modal';
import { Oval } from 'react-loader-spinner';

function TravelAgentBasicInfo(props: travelAgentBasicProps) {
  const { tabId, selectedTabId, setIsSaved, isConfirm, setIsConfirm, setIsRedirect, setTravelAgentId, TravelAgentId, locationsData, setWarningMessages, domainWiseDisable, datalist, setAgentStatusId } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const OutletContext: outletcontext = useOutletContext();
  const [formValue, setFormValue] = useState(new TravelAgentBasicInfoModel());
  const [formError, setFormError] = useState<any>(null);

  const [disabled, setDisabled] = useState(location?.state?.disabled ?? true);
  const [editDisabled, setEditDisabled] = useState(location?.state?.editdisabled ?? true);
  const [clearDisabled, setClearDisabled] = useState(true);

  const [isReady, setIsReady] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [activeId, setActiveId] = useState(true);

  const CityId: any = useRef(null);

  //#region API calling functions
  const gettravelagentbasicinfobyid = async (id: number) => {
    const travelagentbasicinfobyid = await getAllData(`/midoffice/v1/gettravelagentbasicinfobyid?travelAgentId=${id}`)
    if (travelagentbasicinfobyid?.status && travelagentbasicinfobyid?.data) {
      const retrieveData = travelagentbasicinfobyid?.data?.[0];
      setFormValue((form) => ({
        ...form,
        TravelAgentId: retrieveData?.TravelAgentId || 0,
        NameOfCompany: retrieveData?.NameOfCompany || "",
        PointOfContact: retrieveData?.PointOfContact || "",
        EmailId: retrieveData?.EmailId || "",
        PhoneNo: retrieveData?.PhoneNo || "",
        AlternatePhoneNo: retrieveData?.AlternatePhoneNo || "",
        Street: retrieveData?.Street || "",
        CityId: retrieveData?.CityId || 0,
        StateId: retrieveData?.StateId || 0,
        PINCode: retrieveData?.PINCode || "",
        CountryId: retrieveData?.CountryId || 0,
        RegistrationNo: retrieveData?.RegistrationNo || "",
        GSTNo: retrieveData?.GSTNo || "",
        IsActive: retrieveData?.IsActive || false,
      }))
      setActiveId(retrieveData?.IsActive);
      if (retrieveData?.StatusId) {
        UpdateStatusLocalStorage(retrieveData.StatusId);
        setAgentStatusId && setAgentStatusId(retrieveData.StatusId);
      }
    }
  }
  //#endregion

  //#region call API when get token
  useEffect(() => {
    async function fetchData() {
      dispatch(loaderActions.start())
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        const user: any = GetLocalStorage();
        setFormValue((form) => ({ ...form, TravelAgentId: location?.state?.Id ?? 0, UserId: user?.userMasterID ?? 0 }))
        const id: any = localStorage.getItem("taid") !== null ? (localStorage.getItem("taid")) : "";
        const retrieveIdTA: any = id ? decodeURIComponent(id) : 0;
        const TAid = location?.state?.Id > 0 ? location?.state?.Id : retrieveIdTA;
        setTravelAgentId(TAid);
        setIsSaved((save: any) => ({ ...save, BasicInfo: true }));
        Promise.allSettled([
          gettravelagentbasicinfobyid(TAid)
        ])
        dispatch(loaderActions.end())
      }
      else {
        dispatch(loaderActions.end());
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      }

    }
    fetchData();
  }, [])
  //#endregion

  useEffect(() => {
    setIsReady(true);
  }, [])

  //#region call Save/Update function when click on "Yes" on tab change
  useEffect(() => {
    if (isConfirm === 1 && selectedTabId === tabId) {
      handleSaveUpdate();
    }
  }, [isConfirm])
  //#endregion

  //#region onChange functions
  const handleOnChange = (name: string, value: any) => {
    setIsSaved((save: any) => ({ ...save, BasicInfo: false }));
    setEditDisabled(false);
    setClearDisabled(false);
    setFormError(null);
    setFormValue((form) => ({ ...form, [name]: value }));
  }

  const handleSelectChange = (name: string, e: any) => {
    setIsSaved((save: any) => ({ ...save, BasicInfo: false }));
    setEditDisabled(false);
    setClearDisabled(false);
    setFormError(null);
    setFormValue((form) => ({ ...form, CityId: e?.value ? Number(e?.value) : 0, StateId: e?.StateId ?? 0, CountryId: e?.CountryId ?? 0 }));
  }

  const handleisActive = (e: boolean) => {
    if (location?.state?.type !== "Edit") {
      formValue.IsActive = e
      setActiveId(!activeId)
      setFormError(null);
    }
    else {
      setModalShow(true);
    }
  }
  const handleConfirmation = (e: any) => {
    //setYesNoConfirm(e)
    if (e === true) {
      formValue.IsActive = !activeId
      setActiveId(!activeId)
      setEditDisabled(false);
      setFormError(null);
    }
    setModalShow(false);
  }

  //#endregion

  //#region check validations
  const validateData = () => {
    let status = true;
    let error: any = {};

    if (formValue.NameOfCompany?.trim()?.length <= 0) {
      error.NameOfCompany = "Please provide Company Name.";
      status = false;
    }
    else if (datalist?.some((el: any) => el.TravelAgentId !== formValue?.TravelAgentId && el?.NameOfCompany?.trim() === formValue?.NameOfCompany?.trim())) {
      error.NameOfCompany = " This company name already exist.";
      status = false;
    }
    if (formValue.EmailId?.trim()?.length <= 0) {
      error.EmailId = "Cannot Leave blank. Please provide inputs.";
      status = false;
    }
    if (formValue.EmailId && !isValidEmail(formValue.EmailId)) {
      error.EmailId = "Please provide valid Email ID.";
      status = false;
    }
    if (formValue.PhoneNo?.trim()?.length <= 0) {
      error.PhoneNo = "Cannot Leave blank. Please provide inputs.";
      status = false;
    }
    if (formValue.CityId <= 0) {
      error.CityId = "Cannot Leave blank. Please provide inputs.";
      status = false;
    }
    if (formValue.GSTNo && !isValidGST(formValue.GSTNo)) {
      error.GSTNo = "Please provide valid GST No.";
      status = false;
    }

    setFormError(error);

    if (Object.keys(error)?.length > 0) {
      const id = Object.keys(error)?.[0];
      document.getElementById(id)?.focus();
    }

    return status;
  }
  //#endregion

  //#region insert / update data function
  const handleSaveUpdate = async () => {
    setIsConfirm(isConfirm === 1 && selectedTabId === tabId ? 2 : 0);
    if (validateData()) {
      dispatch(loaderActions.start());
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        const insertupdatetravelagenbasicinfo = await postUsersData('/midoffice/v1/insertupdatetravelagenbasicinfo', formValue);
        if (insertupdatetravelagenbasicinfo?.status) {
          setIsSaved((save: any) => ({ ...save, BasicInfo: true }));
          setIsRedirect(true);
          setTravelAgentId(insertupdatetravelagenbasicinfo?.data ? insertupdatetravelagenbasicinfo?.data : 0);
          gettravelagentbasicinfobyid(insertupdatetravelagenbasicinfo?.data);
          localStorage.setItem("taid", encodeURIComponent(insertupdatetravelagenbasicinfo?.data))
          dispatch({ type: 'ALERTING', message: insertupdatetravelagenbasicinfo?.message || ApiNotRespondMessage });
        }
        else {
          dispatch({ type: 'ALERTING', message: insertupdatetravelagenbasicinfo?.message || ApiNotRespondMessage });
        }
        dispatch(loaderActions.end());
      }
      else {
        dispatch(loaderActions.end());
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      }
    }
  }
  //#endregion

  //#region clear function
  const handleClear = () => {
    setIsSaved((save: any) => ({ ...save, BasicInfo: false }));
    setFormValue((form) => ({
      ...form,
      NameOfCompany: "",
      PointOfContact: "",
      EmailId: "",
      PhoneNo: "",
      AlternatePhoneNo: "",
      Street: "",
      CityId: 0,
      StateId: 0,
      PINCode: "",
      CountryId: 0,
      RegistrationNo: "",
      GSTNo: "",
      IsActive: false
    }));
    setFormError(null);
    setActiveId(false);
  }
  //#endregion

  //#region back function
  const handleBack = () => {
    navigate('/travel-agent-management');
  }
  //#endregion


  if (!isReady) {
    return (
      <Modal show={true}>
        <div className="loader">
          <Oval
            height={200}
            width={200}
            color="#122d59"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#122d59"
            strokeWidth={3}
            strokeWidthSecondary={3}
          /></div>
      </Modal>
    )
  }

  return (
    <div className='row mt-5'>
      <ColumnsDevider label='Company Name' isRequired>
        <input type="text"
          id="NameOfCompany"
          className="form-control"
          name='NameOfCompany'
          value={formValue.NameOfCompany}
          onChange={(e: any) => {
            e.target.value?.length <= 100 &&
              handleOnChange(e.target.name, e.target.value)
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder='Company Name'
          maxLength={100}
        />
        {formError?.NameOfCompany && <div className="text-danger fs_14"> {formError?.NameOfCompany} </div>}
      </ColumnsDevider>

      <ColumnsDevider label='Point of Contact'>
        <input type="text"
          id="PointOfContact"
          className="form-control"
          name='PointOfContact'
          value={formValue.PointOfContact}
          onChange={(e: any) => {
            e.target.value?.length <= 100 &&
              handleOnChange(e.target.name, e.target.value)
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder='Point of Contact'
          maxLength={100}
        />
      </ColumnsDevider>

      {/* <ColumnsDevider label='POC Designation'>
        <input type="text"
          id="POC_Designation"
          className="form-control"
          name='OfficeNo'
          // value={form.OfficeNo}
          // disabled={disabled ? true : false}
          // onChange={onChange}
          placeholder='POC Designation' />
      </ColumnsDevider> */}

      <ColumnsDevider label='Email Id' isRequired>
        <input type="text"
          id="EmailId"
          className="form-control"
          name='EmailId'
          value={formValue.EmailId}
          onChange={(e: any) => {
            e.target.value?.length <= 150 &&
              handleOnChange(e.target.name, e.target.value)
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder='Email ID'
          maxLength={150}
        />
        {formError?.EmailId && <div className="text-danger fs_14"> {formError?.EmailId} </div>}
      </ColumnsDevider>

      <ColumnsDevider label='Phone No.' isRequired>
        <input type="text"
          id="PhoneNo"
          className="form-control"
          name='PhoneNo'
          value={formValue.PhoneNo}
          onChange={(e: any) => {
            e.target.value?.length <= 10 &&
              handleOnChange(e.target.name, onlyNumeric(e.target.value))
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder='Phone No.'
          maxLength={10}
        />
        {formError?.PhoneNo && <div className="text-danger fs_14"> {formError?.PhoneNo} </div>}
      </ColumnsDevider>

      <ColumnsDevider label='Alternate Phone No.'>
        <input type="text"
          id="AlternatePhoneNo"
          className="form-control"
          name='AlternatePhoneNo'
          value={formValue.AlternatePhoneNo}
          onChange={(e: any) => {
            e.target.value?.length <= 13 &&
              handleOnChange(e.target.name, onlyNumeric(e.target.value))
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder='Alternate Phone No.'
          maxLength={13}
        />
      </ColumnsDevider>

      {
        !domainWiseDisable.isExternalUser &&
        <ColumnsDevider label='Active'>
          <Switch
            onChange={handleisActive}
            checked={activeId}
            className="react-switch"
            disabled={disabled ? true : false}
          />
          <ConfirmationModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            noconfirm={() => handleConfirmation(false)}
            yesconfirm={() => handleConfirmation(true)}
          />
        </ColumnsDevider>
      }

      <div className='mt-4'><h5 className='fw-bold'>Agency Address</h5></div>

      <ColumnsDevider label='Street'>
        <input type="text"
          id="Street"
          className="form-control"
          name='Street'
          value={formValue.Street}
          onChange={(e: any) => {
            e.target.value?.length <= 150 &&
              handleOnChange(e.target.name, e.target.value)
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder='Street'
          maxLength={150}
        />
      </ColumnsDevider>

      <ColumnsDevider label='City' isRequired>
        <Select
          ref={CityId}
          className="dropdown custom_class select_dropdown"
          options={locationsData?.cityData}
          value={locationsData?.cityData?.filter((fil: any) => fil?.value === formValue.CityId)}
          onChange={(e: any) => handleSelectChange('CityId', e)}
          placeholder="City"
          isDisabled={disabled || domainWiseDisable?.isExternalUser}
          isSearchable
          isClearable
        />
        {formError?.CityId && <div className="text-danger fs_14"> {formError?.CityId} </div>}
      </ColumnsDevider>

      <ColumnsDevider label='State'>
        <Select
          className="dropdown custom_class select_dropdown"
          options={locationsData?.stateData}
          value={locationsData?.stateData?.filter((fil: any) => fil?.value === formValue.StateId)}
          onChange={(e: any) => handleSelectChange('StateId', e)}
          placeholder="State"
          isDisabled
        />
      </ColumnsDevider>

      <ColumnsDevider label='Pin Code'>
        <input type="text"
          id="PINCode"
          className="form-control"
          name='PINCode'
          value={formValue.PINCode}
          onChange={(e: any) => {
            e.target.value?.length <= 6 &&
              handleOnChange(e.target.name, onlyNumeric(e.target.value))
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder='Pin Code'
          maxLength={6}
        />
      </ColumnsDevider>

      <ColumnsDevider label='Country'>
        <Select
          className="dropdown custom_class select_dropdown"
          options={locationsData?.countryData}
          value={locationsData?.countryData?.filter((fil: any) => fil?.value === formValue.CountryId)}
          onChange={(e: any) => handleSelectChange('CountryId', e)}
          placeholder="Country"
          isDisabled
        />
      </ColumnsDevider>

      <div className='row m-0 p-0'>
        <ColumnsDevider label='Registration No.'>
          <input type="text"
            id="RegistrationNo"
            className="form-control"
            name='RegistrationNo'
            value={formValue.RegistrationNo}
            onChange={(e: any) => handleOnChange(e.target.name, alphaNumericspace(e.target.value))}
            disabled={disabled || domainWiseDisable?.isExternalUser}
            placeholder='Registration No.'
          />
        </ColumnsDevider>

        <ColumnsDevider label='GST No.'>
          <input type="text"
            id="GSTNo"
            className="form-control"
            name='GSTNo'
            value={formValue.GSTNo?.toUpperCase()}
            onChange={(e: any) => {
              e.target.value?.length <= 15 &&
                handleOnChange(e.target.name, e.target.value?.toUpperCase())
            }}
            disabled={disabled || domainWiseDisable?.isExternalUser}
            placeholder='GST No.'
            maxLength={15}
          />
          {formError?.GSTNo && <div className="text-danger fs_14"> {formError?.GSTNo} </div>}
        </ColumnsDevider>
      </div>

      <div className="mt-3 d-flex justify-content-center mt-5">
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnAdd" onClick={handleSaveUpdate} disabled={editDisabled || disabled || domainWiseDisable?.isExternalUser} > {domainWiseDisable?.loginUserDomainMasterId !== 1 ? "Save AS Draft" : (location?.state?.type === "Edit" ? "Update" : "Save")} </button>
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnClear" onClick={handleClear} disabled={clearDisabled || disabled || domainWiseDisable?.isExternalUser} >Clear</button>
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnBack" onClick={handleBack} disabled={domainWiseDisable?.isOnBording === 1} >Back</button>
      </div>
    </div>
  )
}

export default TravelAgentBasicInfo